import React, { useEffect, useState } from 'react';
import classes from './HeaderFavoriteList.module.css';
import { Link, useNavigate } from 'react-router-dom';
import image from '../../assets/images/house.jpg';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import NoData from '../NoData/NoData';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import Tabs from '../Tabs';
import { useLazyGetApiQuery } from '../../store/apiSlice/apiSlice';
import { useTranslation } from 'react-i18next';

const Notifications = ({ item, type, isFav, onToggle }) => {
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);

  let _type = ['event', 'project'].includes(type) ? `${type}s` : type;

  return (
    <Link className="text-decoration-none" to={`/${_type}/${item?.slug}`}>
      <div className={classes.HeaderNotificationInnerDiv}>
        <div className={classes.headerContent}>
          <div className={classes.ImgDiv}>
            <img src={image} alt="" />
          </div>
          <div className={classes.contentDiv}>
            <div className={classes.price}>
              <p>${item?.price}</p>
              {item?.propertyType?.en === 'Rent' && <p>Per Month</p>}
            </div>
            <div className={classes.titleDiv}>
              <h6>{item?.title?.[selectedLanguage]}</h6>
            </div>
            <div className={classes.content}>
              <p>
                <span>Type:</span> {item?.[`${type}Type`]?.title?.[selectedLanguage]}
              </p>
            </div>
          </div>
        </div>
        <div
          onClick={(e) => {
            e.preventDefault(); // stop Link navigation
            onToggle();
          }}>
          {isFav ? (
            <AiFillHeart className={classes.icon} />
          ) : (
            <AiOutlineHeart className={classes.icon} />
          )}
        </div>
      </div>
    </Link>
  );
};

const HeaderFavoriteList = () => {
  const { t } = useTranslation('webCommon');

  const [getApiFunc, { isLoading, isFetching, data: response }] = useLazyGetApiQuery();
  const tabsData = [
    {
      id: 1,
      text: `${t('webHeader.savedHeader.properties')} (${response?.savedProperties || 0})`,
      icon: <AiFillHeart />,
      path: '/saved-properties',
      type: 'property'
    },
    {
      id: 2,
      text: `${t('webHeader.savedHeader.events')} (${response?.savedEvents || 0})`,
      icon: <AiFillHeart />,
      path: '/saved-events',
      type: 'event'
    },
    {
      id: 3,
      text: `${t('webHeader.savedHeader.projects')} (${response?.savedProjects || 0})`,
      icon: <AiFillHeart />,
      path: '/saved-projects',
      type: 'project'
    }
  ];

  const [tabValue, setTabValue] = useState(tabsData[0]);
  // const [favorites, setFavorites] = useState({});

  const navigate = useNavigate();

  const getData = async (type = tabValue?.type) => {
    await getApiFunc({
      url: `users/getMyFavorites?type=${type}&page=${1}&limit=${5}&sortBy=${-1}`,
      tag: `SavedPropertiesEventsProjects`
    });
  };

  // const toggleFavorite = (id) => {
  //   setFavorites((prev) => ({
  //     ...prev,
  //     [id]: !prev[id]
  //   }));
  // };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className={classes.HeaderNotification}>
      <div className={classes.notificationHeader}>
        <AiFillHeart size={25} color="white" />
        <h6>{t('webHeader.favoritePopup.title')}</h6>
      </div>

      <Tabs
        className={classes.tab_main}
        tabClass={classes.tab_class_main}
        value={tabValue}
        setValue={(e) => {
          getData(e?.type);
          setTabValue(tabsData.find((item) => item.type === e.type));
        }}
        tabsData={tabsData}
      />
      <div className={classes.notificationSkeleton}>
        {isLoading || isFetching ? (
          Array.from({ length: 5 }, (_, i) => (
            <Skeleton key={i} height={'80px'} width={'100%'} variant={'rectangular'} />
          ))
        ) : response?.data?.length === 0 ? (
          <NoData text={t('webHeader.favoritePopup.noData')} className={classes.noData} />
        ) : (
          response?.data?.map((item, i) => (
            <div className={classes.mb16} key={i}>
              <Notifications
                item={item?.entity}
                type={tabValue?.type}
                // isFav={favorites[item?.entity?._id]}
                // onToggle={() => toggleFavorite(item?.entity?._id)}
              />
            </div>
          ))
        )}
      </div>
      <p
        className={['p18', classes.viewAll].join(' ')}
        onClick={() => navigate('/saved-properties')}>
        {t('webHeader.favoritePopup.seeAll')}
      </p>
    </div>
  );
};

export default HeaderFavoriteList;
